<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModalCuentaContable'" [idClose]="'closeModal'"
                [idOpen]="'openModal'"
                [innTemplate]="bodyModalCuentaContable" [titulo]="'Cuenta Contable'">
</app-lfsa-modal>
<ng-template #bodyModalCuentaContable>
  <app-lfsa-alerts [class]="'primary'" [listaVacia]="listaVaciaCuentaContable" [loading]="loadingCuentaContable"
                   [texto]="'No se encontraron datos en el listado de Cuenta Contable.'"></app-lfsa-alerts>
  <ag-grid-angular #agGrid (gridReady)="onGridReadyProveedores($event)" *ngIf="!listaVaciaCuentaContable"
                   [columnDefs]="columnDefsCuentaContable" [frameworkComponents]="frameworkComponentsCuentaContable"
                   [paginationPageSize]="modulo.agGrid.paginacion"
                   [pagination]="true" [rowData]="rowDataCuentaContable"
                   [rowSelection]="rowSelectionCuentaContable" class="ag-theme-alpine"
                   style="width: 100%; height: 400px;">
  </ag-grid-angular>
</ng-template>
